import { motion } from "framer-motion";

export default function ServiceCard({ icon, title, desc }) {
  return (
    <motion.div
      whileHover={{ scale: 1.05, y: -6 }}
      transition={{ type: "spring", stiffness: 200 }}
      className="group bg-white/70 backdrop-blur-md rounded-2xl p-8 shadow-lg border border-gray-100 hover:border-indigo-500/40 hover:shadow-indigo-300/30 transition-all duration-300"
    >
      <div className="mb-4 flex justify-center">{icon}</div>
      <h3 className="text-xl font-semibold text-gray-800 mb-2 group-hover:text-indigo-600 transition">
        {title}
      </h3>
      <p className="text-gray-600 leading-relaxed">{desc}</p>
    </motion.div>
  );
}
